// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zgslxuchxxnvhitkvzgh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpnc2x4dWNoeHhudmhpdGt2emdoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkwODQzNDQsImV4cCI6MjA3NDY2MDM0NH0.e5eFLyUxHI5jPkBs2KNf98grY6SFsqtWPSHJTHEJrEo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});